import ceo from "../assets/images/profil-photo.png"
import right from "../assets/images/chevron-right.png"


export default function Founder() {
  return (
    <div className="bg-founder bg-no-repeat bg-cover">
      <div className="container py-[250px]">
        <h1 className="text-center mb-[60px]">The Founder:</h1>
        <div className="flex justify-center">
        <div className="inline-flex max-sm:flex-col bg-purple100 p-4 rounded-3xl items-center gap-5 ">
          <img src={ceo} alt="ceo" />
          <div>
          <p className="text-[24px]">David Adebajo</p>
          <p className="text-[#9892A3] text-[14px]">CEO, Systems Architect</p></div>
          <img src={right} alt="right" className="size-4 sm:ml-28" />
          
        </div></div>
        <p className="text-center mt-[34px] font-ibm">
            "The educator is not a deliverer of content, <br />
            but an architect of
            cognitive ecosystems.”
          </p>
      </div>
    </div>
  );
}
